import { render, staticRenderFns } from "./LKPublicationsFormdataView.vue?vue&type=template&id=5831cb76&"
import script from "./LKPublicationsFormdataView.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports